
const $ = require('rgs-jquery');

const window = require('window');

function closeMenus () {
	$('#main-navbar-collapse').collapse('hide');
	$('#main-navbar-collapse .dropdown.open > [data-toggle="dropdown"]').dropdown('toggle');
}

$('#main-navbar-collapse > .nav').on('show.bs.dropdown hidden.bs.dropdown', '*', function (e) {
	$(e.target).closest('.nav').toggleClass('child-open', e.type == 'show');
});

$('#main-content').on('click', function () {
	$('#main-navbar-collapse').collapse('hide');
});

$('.rgs-main-menu-category .collapse').addClass('animated slideInRight');

$(window).on('scroll.rgs.main-menu', function () {
	if (!$('#main-navbar-collapse').is(':visible')) {
		return;
	}

	const scrollTop = window.document.body.scrollTop;
	const pageHeight = $(window.document.body).height();
	const windowHeight = $(window).height();

	if (scrollTop > ((Math.max(pageHeight, windowHeight) / 2) - (windowHeight / 2))) {
		closeMenus();
	}
});

